let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jP282")).then(() => parcelRequire('g39Mt'));